module.exports = __webpack_public_path__ + "img/down-arrow-settings.34cc5d49.svg";